import { Injectable } from '@angular/core';
import { SpecializedRolesApiClient } from './specialzied-roles.api.client';
import { SpecializedRolesInMemoryApiClientProvider as AccountUsersInMemoryApiClient } from './specialzied-roles.in-memory-api.client';
import { ISpecializedRolesApiClient } from './i-specialzied-roles.api.client';
import { ApiClientProvider } from '../../../../core';

@Injectable({
  providedIn: 'root'
})
export class SpecialziedRolesApiClientProvider extends ApiClientProvider<ISpecializedRolesApiClient> {
  constructor(
    private client: SpecializedRolesApiClient,
    private inMemoryClient: AccountUsersInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): ISpecializedRolesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): ISpecializedRolesApiClient {
    return this.client;
  }
}
